<template>
  <div class="history-container">
    <div class="header">
      <div>Transaction history: </div>
      <div>Deposit: {{ deposit }}</div>
      <div>Withdrawal: {{ withdrawal }}</div>
      <div>Credit: {{ credit }}</div>
      <div>Commision: {{ commision }}</div>
      <div>Swap: {{ swap }}</div>
      <div>Profit/Loss: {{ profitLoss }}</div>
    </div>
    <div class="table">
      <table>
        <tr>
          <th>Ticket</th>
          <th>Time</th>
          <th>Type</th>
          <th>Size</th>
          <th>Symbol</th>
          <th>Price</th>
          <th>S/L</th>
          <th>T/P</th>
          <th>Time</th>
          <th>Price</th>
          <th>Commision</th>
          <th>Swap</th>
          <th>Profit</th>
          <th>Status</th>
          <th>Amount</th>
        </tr>
        <template v-for="row in rows">
          <tr>
            <td v-for="item in row" :class="{
              'approved': item === 'Approved',
              'pending': item === 'Pending',
              'denied': item === 'Denied'
            }">{{ item }}</td>
          </tr>
        </template>
      </table>
    </div>
    <div class="cabinet-table-button">
      <button>1</button>
    </div>
    <button class="red-button" @click="download">Download History Report</button>
  </div>
</template>

<script>
export default {
  name: "History",
  data() {
    return {
      deposit: 0,
      withdrawal: 0,
      credit: 0,
      commision: 0,
      swap: 0,
      profitLoss: 0,

      rows: []
    };
  },
  created() {
    this.rows = [];
    for (let i = 0; i < 10; i++) {
      let status = null;
      let statusNumber = this.getRndInteger(0, 3);
      switch (statusNumber) {
        case 0:
          status = 'Approved'
          break
        case 1:
          status = 'Pending'
          break
        case 2:
          status = 'Denied'
          break
      }
      this.rows.push([
        17421419 + i,
        '2019.01.02 16:10',
        'Transfer',
        10.00,
        'BTCUSD',
        3590.69,
        0.00,
        0.00,
        '2019.01.17 16:50',
        3590.80,
        -53.86,
        '',
        1.00,
        status,
        30.00
      ]);
    }

    console.log(this.rows);
  },
  methods: {
    download() {
      console.log('download!');
    },
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    }
  }
}
</script>

<style scoped>

</style>
